// @flow

import React, { Component, type ComponentType } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { onImpressionClick, onCarImpression, addImpressionPosition } from '../../store/gtm';
import withDidAppear from '../withDidAppear';

type DispatchProps = {|
  processGtmEvent: Function,
  onImpression: Function,
  addCarImpression: Function,
|};

type OwnProps = {|
    pdbId: string,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
|};

const withGTMImpression = (WrappedComponent: ComponentType<*>) => {
  class Enhancer extends Component<Props> {
    componentDidMount() {
      const { pdbId, addCarImpression } = this.props;
      addCarImpression(pdbId);
    }

    componentDidAppear = () => {
      const { pdbId, onImpression } = this.props;
      if (pdbId) {
        onImpression(pdbId);
      }
    }

    render() {
      const { processGtmEvent, pdbId } = this.props;

      return (
        <WrappedComponent
          processGtmEvent={() => processGtmEvent(pdbId)}
          {...this.props}
          pdbId={pdbId}
        />
      );
    }
  }

  const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    processGtmEvent: (id: string) => dispatch(onImpressionClick(id)),
    onImpression: (id: string) => dispatch(onCarImpression(id)),
    addCarImpression: (id: string) => dispatch(addImpressionPosition(id)),
  });

  return compose(
    connect<Props, OwnProps, any, DispatchProps, any, any>(null, mapDispatchToProps),
    c => withDidAppear(c, true),
  )(Enhancer);
};

export default withGTMImpression;
